import { render, staticRenderFns } from "./AccessErrorView.vue?vue&type=template&id=63f01482&"
import script from "./AccessErrorView.vue?vue&type=script&lang=ts&"
export * from "./AccessErrorView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports